import { render, staticRenderFns } from "./ConfigurationInfoStep.vue?vue&type=template&id=2824c725"
import script from "./ConfigurationInfoStep.vue?vue&type=script&lang=ts"
export * from "./ConfigurationInfoStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports